import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { IdDescription } from 'tms-lib';
import { TmsWebBaseEditService } from 'tms-web-shared';
import { PieceFault } from '../../../models';

@Injectable({
  providedIn: 'root',
})
// Faults recorded against a piece's cloth. ⚠️ A fault hangs off the STOCK ITEM, so it can
// only be recorded once the piece has been WOVEN - that is when the stock item is created.
export class PieceFaultService extends TmsWebBaseEditService<PieceFault, PieceFault> {
  constructor() {
    super('PieceFault', $localize`Fault`);
  }

  // The faults this piece's product type allows, narrowed to the process where the fault
  // list states one. Faults with no process stated apply everywhere.
  getAvailable(pieceId: string, processId?: string): Observable<IdDescription[]> {
    const query = processId ? `?processId=${processId}` : '';
    return this.httpService.get<IdDescription[]>(`${this.apiUrl}/Available/${pieceId}${query}`);
  }

  getForPiece(pieceId: string): Observable<PieceFault[]> {
    return this.httpService.get<PieceFault[]>(`${this.apiUrl}/Piece/${pieceId}`);
  }
}
